// Pure formatting / id helpers.

export const newId = (): string =>
  crypto.randomUUID?.() ?? String(Date.now() + Math.random());

export const dayKey = (ts: number): string =>
  new Date(ts).toLocaleDateString("fr-FR", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });

export const timeLabel = (ts: number): string =>
  new Date(ts).toLocaleTimeString("fr-FR", {
    hour: "2-digit",
    minute: "2-digit",
  });

export const emailSubject = (text: string): string => text.slice(0, 80);
